export function formatPhoneNumber(phoneNumberString: string) {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = /^(\d{3})(\d{3})(\d{4})$/.exec(cleaned);

  const areaCode = match?.[1];
  const firstThree = match?.[2];
  const lastFour = match?.[3];

  if (!areaCode || !firstThree || !lastFour) {
    return null;
  }

  return `(${areaCode}) ${firstThree}-${lastFour}`;
}
